// extracted by mini-css-extract-plugin
export default {"tick-stem":"SllXRS","tick-branch":"_EF3y1","wrapper":"pufOk2","tick":"UGmYAv","background":"GeX8ed"};